import { Checkbox as CheckboxComponent } from './Checkbox';
import { CheckboxGroup } from './CheckboxGroup';

// Compound Component 패턴: Checkbox.Group
export const Checkbox = Object.assign(CheckboxComponent, {
  Group: CheckboxGroup,
});

export type { CheckboxProps } from './Checkbox';
export type { CheckboxGroupProps } from './CheckboxGroup';
